// extracted by mini-css-extract-plugin
export default {"appContainer":"ContactList_appContainer__KLhOA","glow":"ContactList_glow__SxG-b","contactList":"ContactList_contactList__4h-dW"};